module.exports = __webpack_public_path__ + "img/10.0b5b7d64.jpg";